import { makeStyles } from '@mui/styles';

const useDivisionInformationStyles = makeStyles({
	root: {
		backgroundColor: 'white',
		marginBottom: 8,
		padding: '24px 16px',
	},
	headerContainer: {
		alignItems: 'center',
		display: 'flex',
		flexFlow: 'column wrap',
		justifyContent: 'center',
	},
});

export default useDivisionInformationStyles;
